// extracted by mini-css-extract-plugin
export var copyableField = "_r4-4";
export var customerBadge = "_r4-0";
export var customerInfoTitle = "_r4-2";
export var details = "_r4-1";
export var dropdownContainer = "_r4-5";
export var dropdownImage = "_r4-6";
export var editAssigneeForm = "_r4-a";
export var editButton = "_r4-3";
export var email = "_r4-7";
export var hidden = "_r4-d";
export var input = "_r4-8";
export var saveButton = "_r4-b";
export var shopifyIcon = "_r4-c";
export var suggestionBadge = "_r4-e";
export var suggestionText = "_r4-f";
export var username = "_r4-9";